import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';
function isSub(item) {
  return typeof item.renderSub === 'function';
}
export default class MoreButtonsPopover extends Component {
  open = false;
  pos = {
    top: -9999,
    left: -9999
  };
  visible = false;
  raf1 = null;
  raf2 = null;
  view() {
    const {
      items
    } = this.attrs;
    return m("span", {
      class: "Magicbb-MoreWrap",
      style: "display:inline-block"
    }, m(Button, {
      className: "Button Button--icon Button--link",
      icon: this.attrs.icon || 'fas fa-wand-sparkles',
      onclick: e => {
        e?.preventDefault?.();
        this.anchor = e.currentTarget;
        this.toggle();
      },
      title: this.attrs.label || 'More',
      "aria-expanded": this.open ? 'true' : 'false',
      "aria-haspopup": "menu"
    }), this.open && m("div", {
      class: "Magicbb-MorePopover",
      style: {
        top: `${this.pos.top}px`,
        left: `${this.pos.left}px`,
        visibility: this.visible ? 'visible' : 'hidden',
        willChange: 'top, left'
      },
      oncreate: vnode => {
        this.popEl = vnode.dom;
        this.raf1 = requestAnimationFrame(() => {
          this.positionAbove();
          this.raf2 = requestAnimationFrame(() => {
            this.positionAbove();
            this.visible = true;
            m.redraw();
          });
        });
      },
      onremove: () => this.cleanup(),
      role: "menu"
    }, m("div", {
      class: "Magicbb-MoreRow"
    }, items.map(it => isSub(it) ? m("span", {
      key: it.key,
      class: "Magicbb-MoreBtnIcon",
      title: it.title,
      role: "menuitem",
      tabindex: "0",
      "aria-label": it.title,
      "aria-haspopup": "dialog",
      "aria-expanded": "false"
    }, it.renderSub()) : m(Tooltip, {
      key: it.key,
      text: it.title,
      position: "top"
    }, m("button", {
      class: "Magicbb-MoreBtnIcon",
      role: "menuitem",
      "aria-label": it.title,
      type: "button",
      onclick: e => {
        e?.preventDefault?.();
        const fn = it.onClick;
        this.close();
        requestAnimationFrame(() => fn(e));
      }
    }, it.icon ? m("i", {
      class: it.icon,
      "aria-hidden": "true"
    }) : m("i", {
      class: "fas fa-circle",
      style: "opacity:.35",
      "aria-hidden": "true"
    })))))));
  }
  toggle() {
    this.open ? this.close() : this.openPopover();
  }
  openPopover() {
    this.open = true;
    this.visible = false;
    this.pos = {
      top: -9999,
      left: -9999
    };
    m.redraw();
    window.addEventListener('resize', this.onWin, {
      passive: true
    });
    window.addEventListener('scroll', this.onWin, true);
    document.addEventListener('mousedown', this.onDocDownCapture, true);
    document.addEventListener('click', this.onDocClickCapture, true);
    document.addEventListener('keydown', this.onKey);
  }
  close() {
    this.open = false;
    this.visible = false;
    m.redraw();
    this.cleanup();
  }
  cleanup() {
    if (this.raf1) cancelAnimationFrame(this.raf1);
    if (this.raf2) cancelAnimationFrame(this.raf2);
    this.raf1 = this.raf2 = null;
    window.removeEventListener('resize', this.onWin);
    window.removeEventListener('scroll', this.onWin, true);
    document.removeEventListener('mousedown', this.onDocDownCapture, true);
    document.removeEventListener('click', this.onDocClickCapture, true);
    document.removeEventListener('keydown', this.onKey);
  }
  onWin = () => {
    if (!this.open) return;
    this.positionAbove();
    m.redraw();
  };
  onKey = ev => {
    if (ev.key === 'Escape') this.close();
  };
  onDocDownCapture = ev => {
    if (!this.open) return;
    const target = ev.target;
    const moreRoot = this.element;
    const nativePopover = document.querySelector('.Magicbb-ColorPopover, .Magicbb-AlertPopover, .Magicbb-ImagePopover');
    const insideMore = !!moreRoot && moreRoot.contains(target);
    const insideNative = !!nativePopover && nativePopover.contains(target);
    if (insideMore || insideNative) return;
    this.close();
  };
  onDocClickCapture = ev => {
    if (!this.open) return;
    const target = ev.target;
    const nativePopover = document.querySelector('.Magicbb-ColorPopover, .Magicbb-AlertPopover, .Magicbb-ImagePopover');
    if (nativePopover && nativePopover.contains(target)) {
      requestAnimationFrame(() => this.close());
    }
  };
  positionAbove() {
    const ar = this.anchor?.getBoundingClientRect();
    if (!ar) return;
    const rect = this.popEl?.getBoundingClientRect();
    const pw = rect?.width ?? 240;
    const ph = rect?.height ?? 44;
    const vw = document.documentElement.clientWidth || window.innerWidth;
    const isMobile = vw <= 768;
    const leftGutter = 8;
    const rightGutter = 8;
    const reserveRightForInner = isMobile ? 220 : 0;
    let left = Math.round(ar.left);
    const maxLeft = vw - pw - reserveRightForInner - rightGutter;
    if (left > maxLeft) left = Math.max(leftGutter, maxLeft);
    if (left < leftGutter) left = leftGutter;
    let top = Math.round(ar.top - ph - 6);
    if (top < 8) top = 8;
    this.pos.left = left;
    this.pos.top = top;
  }
}
flarum.reg.add('forumaker-magicbb', 'forum/components/MoreButtonsPopover', MoreButtonsPopover);